<template>
  <div>
    <b-table
      responsive
      :items="items"
      :fields="fields"
    >
      <!-- A custom formatted price column -->
      <template #cell(price)="data">
        <display-currency :value="data.value" />
      </template>
      <!-- A custom formatted messages_count column -->
      <template #cell(messages_count)="data">
        {{ data.value | numberFormat }}
      </template>
      <!-- A custom formatted status column -->
      <template #cell(status)="data">
        <display-status
          :value="data.value"
          :text="data.item.display_status"
        />
      </template>
      <!-- A custom formatted created_at column -->
      <template #cell(created_at)="data">
        <display-date-time :value="data.value" />
      </template>
      <!-- A custom formatted action column -->
      <template #cell(action)="data">
        <b-button
          v-if="$can('update', 'panels')"
          variant="flat-success"
          size="sm"
          class="btn-icon rounded-circle"
          @click="editButtonClicked(data.item)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-button>
      </template>
    </b-table>
    <div
      v-if="!items.length"
      class="d-flex justify-content-center align-items-center"
    >
      <h6 class="font-weight-bolder mb-0">
        {{ $t("There are no panels to display") }}
      </h6>
    </div>
    <panels-edit-modal
      :form="editForm"
      :additional-data="additionalData"
      @onHideModal="resetEditForm"
    />
  </div>
</template>

<script>
import { ListTable } from '../../../../common/mixins/list'
import PanelsEditModal from '../edit/PanelsEditModal'

export default {
  name: 'PanelsList',
  components: { PanelsEditModal },
  mixins: [ListTable],
  data() {
    return {
      routeName: 'panels',
    }
  },
}
</script>

<style scoped>

</style>
